import { Icons } from './icons/icon-set';

interface InputPanelProps {
  stdin: string;
  setStdin: (v: string) => void;
  args: string;
  setArgs: (v: string) => void;
  onClose: () => void;
}

export function InputPanel({ stdin, setStdin, args, setArgs, onClose }: InputPanelProps) {
  return (
    <div class="inputpanel">
      <div class="inputpanel-head">
        <Icons.terminal size={13} /> Input
        <button class="iconbtn" style={{ marginLeft: 'auto' }} onClick={onClose} title="Close">
          <Icons.x size={14} />
        </button>
      </div>
      <div class="inputpanel-grid">
        <div class="inputpanel-cell">
          <label>STDIN (standard input)</label>
          <textarea
            class="field"
            value={stdin}
            onInput={(e) => setStdin((e.target as HTMLTextAreaElement).value)}
            placeholder="Each line is one fgets(STDIN)…"
          />
        </div>
        <div class="inputpanel-cell">
          <label>Command-line arguments ($argv)</label>
          <input
            class="field"
            value={args}
            onInput={(e) => setArgs((e.target as HTMLInputElement).value)}
            placeholder="e.g. --name=Alice --verbose"
          />
        </div>
      </div>
    </div>
  );
}
